import * as React from "react";
export class Header extends React.Component {
    render() {
        return (React.createElement("div", { className: "rj-dialog-message__header" },
            React.createElement("div", { className: "rj-dialog-message__header-content" },
                this.props.html && React.createElement("div", { className: "rj-dialog-message__header-html", "data-uat": this.props.dataUat, dangerouslySetInnerHTML: { __html: this.props.html } }),
                this.props.children)));
    }
}
//# sourceMappingURL=Header.js.map